// Loader.js

import React from 'react';
import '../assets/styles/Loader.css'; // Import CSS for styling

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
